import { render } from "./VtoApp.vue?vue&type=template&id=79e60200"
import script from "./VtoApp.vue?vue&type=script&lang=js"
export * from "./VtoApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__